<template lang="pug">
  li
    f7-link(
      href="#"
      class="item-content"
      @click="$emit('click', $event)")
      .item-media
        video-thumbnail-list(:src="curriculum.video.thumbnailUrl")
      .item-inner
        .item-title-row
          .item-title(style="-webkit-box-orient: vertical;") {{ curriculum.title }}
        .item-subtitle(style="-webkit-box-orient: vertical;")
          label
            icon(name="write")
            span(class="date-with-icon") {{ dateFormat(curriculum.createdTime) }}
</template>

<style lang="scss" scoped>
.item-content {
  @extend %curriculum-list-item;

  .item-subtitle {
    -webkit-box-pack: center;
    margin-top: 6px;
    height: 24px;
  }
}
</style>

<script>
import VideoThumbnailList from '@/components/atoms/VideoThumbnailList'
import Formatter from '@/components/mixins/Formatter'

export default {
  components: { VideoThumbnailList },
  mixins: [Formatter],
  props: {
    curriculum: {
      type: Object,
      required: true,
    },
  },
}
</script>
